<div class="embed-container">
  <iframe
    [src]="powerAppUrl"
    width="100%"
	height="768"
    frameborder="0"
    allowfullscreen
	class="powerApp"
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
  ></iframe>
</div>
